interface IProps {
    onClickPrevTransactionBtn: () => void;
}

const ActivityItemInfo = ({ onClickPrevTransactionBtn }: IProps) => {
    return (
        <li className="transaction-info activity-area-last-item">
            <p className="body-s fw-b n-gray">최근 20건의 기록만 노출됩니다.</p>
            <button className="btn-area" type="button" onClick={onClickPrevTransactionBtn}>
                <span className="btn-text fw-b n-gray">이전거래 보러가기</span>
                <div className="icon-area">
                    <img src="img/box-arrow-up-right.png" alt="box-arrow-up-right.png" />
                </div>
            </button>
        </li>
    )
}

export default ActivityItemInfo;    